var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSquareRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-square-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.5 9.33333L9.83333 7M9.83333 7L7.5 4.66667M9.83333 7H5.16667M5.05 12.25H9.95C10.9301 12.25 11.4201 12.25 11.7945 12.0593C12.1238 11.8915 12.3915 11.6238 12.5593 11.2945C12.75 10.9201 12.75 10.4301 12.75 9.45V4.55C12.75 3.56991 12.75 3.07986 12.5593 2.70552C12.3915 2.37623 12.1238 2.10852 11.7945 1.94074C11.4201 1.75 10.9301 1.75 9.95 1.75H5.05C4.06991 1.75 3.57986 1.75 3.20552 1.94074C2.87623 2.10852 2.60852 2.37623 2.44074 2.70552C2.25 3.07986 2.25 3.56991 2.25 4.55V9.45C2.25 10.4301 2.25 10.9201 2.44074 11.2945C2.60852 11.6238 2.87623 11.8915 3.20552 12.0593C3.57986 12.25 4.06991 12.25 5.05 12.25Z",
    stroke: "#006400",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSquareRight);
export default __webpack_public_path__ + "static/media/icon_square_right.ec7a1e03e1a76227e8a16ea3add406df.svg";
export { ForwardRef as ReactComponent };